import { grey } from "@mui/material/colors";

import { pageStyles } from "components/Styled/Page/styles";
import { tableStyles } from "components/Styled/Table/sharedStyles";
import { TemplateContentType } from "features/Influencer/ContactList/schema";

const styles = {
  ...pageStyles,
  ...tableStyles,
  button: {
    fontSize: 14,
    color: grey[600],
    "&:hover": {
      color: "black",
    },
  },
  contentTypeChip: (contentType: TemplateContentType) => ({
    backgroundColor:
      contentType === TemplateContentType.OUTREACH ? "#dbeafd" : "#f2e6fe",
    color: contentType === TemplateContentType.OUTREACH ? "#5477d0" : "#9549c7",
    fontSize: 12,
    px: 1,
  }),
  nichesChip: {
    fontSize: 14,
    fontWeight: 500,
  },
  moreChip: {
    opacity: 0.5,
    pl: 3,
    backgroundColor: grey[200],
    color: "black",
    ml: -4,
    zIndex: 1,
  },
  root: {
    pb: "60px",
  },
  banner: {
    backgroundColor: "secondary.light",
    px: 2,
    py: 1,
    borderRadius: 4,
  },
  card: {
    borderRadius: 2,
    border: `1px solid ${grey[200]}`,
    boxShadow: "none",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  menuButton: {
    fontSize: 14,
    color: grey[500],
    "&:hover": {
      color: "black",
    },
  },
  templateName: {
    fontSize: 16,
    fontWeight: 600,
    color: "black",
  },
  lastModified: {
    fontSize: 11,
    color: grey[600],
  },
  filterContainer: {
    mt: 2,
    backgroundColor: "#f7f7f5",
    borderRadius: 30,
    width: "max-content",
    overflow: "hidden",
    p: 1,
    mb: { xs: 2, md: 0 },
  },
  filterActive: {
    fontSize: 14,
    borderRadius: 30,
    backgroundColor: "white",
    color: "black",
    textTransform: "none",
    px: 2,
    "&:hover": {
      color: "black",
      border: "1px solid",
      backgroundColor: "yellow.main",
    },
  },
  filterInactive: {
    fontSize: 14,
    borderRadius: 30,
    textTransform: "none",
    px: 2,
    color: grey[700],
  },
};

export default styles;
